export class IssueConfigModel {
  VolumeMaxChar: number = 0;
  IssueMaxChar: number = 0;
  PagesMaxChar: number = 0;
  AnnualBudget: number = 0;
  LoadDataList: string = "";
  IssueConfigDetails: string = "";
  JournalListAPI: string = "";
  UpdateIssueConfig: string = "";
  JournalWarning: string = "";
  YearWarning: string = "";
  VolumeWarning: string = "";
  IssueWarning: string = "";
  UploadImpoertfileAPI: any;
  DownloadsamplefileAPI: any;

}
